import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import SettingListItem from '../SettingListItem';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';
import functions from '../../../util/functions';
import { useGym } from '../../../DataStore/Gym/GymContext';

const GymConfig = () => {

    const {openSettings} = useTheme();

    const [activeRecord, setActiveRecord] = useState(null);
    const {getConfig, configListing} = useGym();


    useEffect(()=>{
        getConfig();
    }, [])

    const handleRefresh = ()=>{
        getConfig(true);
    }

    const handleConfig = (field)=>{
        openSettings("Gym Configuration", "ConfigGym", field);
    }

   
    const menu = ()=>{

        return(<>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-refresh"> </i><span>Refresh</span>
            </button>
           
        </>)
    }

    const extractValue = config=>{
        switch(config.config_code){
            case "payee_id":
                return config.config_value?.title || config.config_value;
            default:
                return functions.isObject(config.config_value) ? config.config_value.account_number + ' - ' + config.config_value.account_name  : config.config_value;

        }
    }

    return (
        <SettingContainer
            title="Gym Configuration"
            icon="fa fa-dumbbell"
            Menu={menu}
            >
      
            {functions.isObject(configListing) && <ul className="list-group">
                {Object.values(configListing).map((config) => (
                    
                    <SettingListItem
                        key={config.id} 
                        iconName={config.icon}
                        itemName={config.config_name}
                        itemDescription={extractValue(config)}
                        buttonTitle="Configure"
                        onSelect={()=>setActiveRecord(config)}
                        active={config.id === activeRecord?.id}
                        buttonAction={()=>handleConfig(config)}
                    />
                        
                ))}
            </ul>}
            {configListing === '404' && <Notification message="No Gym configurations found" />}
            {!configListing && <ActivityLoader />}
       </SettingContainer>

      
    );
};

export default GymConfig;
